enum NavigationTabRefs {
    FOCUS_HISTORY = 'focus_history',
    METRIC_SELECTION = 'metric_selection',
    FOCUS_SELECTION = 'focus_selection',
    LOAD_GOALS = 'load_goals',
}

export default NavigationTabRefs;
